import React from "react";

const TranslationImp = () => {
  return (
    <div className="transHeadContent">
      <h2>
        Importance of <span>Translation</span> Services{" "}
      </h2>
      <p>
        Translation can bridge the linguistic gap between different languages,
        facilitating clear and effective communication. Diverse types of
        translations are required for various purposes, each needing specific
        expertise. For example, legal translations require an authorized
        translator. Goodway Attestation was established to overcome language
        barriers that might interfere with daily activities. We carefully
        consider the customer’s needs and the type of language conversion
        required. Our dedication to accuracy has earned us a reputation for
        excellence in translation services.
      </p>
    </div>
  );
};

export default TranslationImp;
